import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'home.title',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'ACL_00007',
                },
                url: {
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: `settings.titles`,
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'ACL_00052',
                    config                  : 'ACL_00052',
                    configEdit              : 'ACL_00071',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/settings`,
                },
            },
            modules: {
                menu: {
                    route: `${code}.modules`,
                    text: 'modules.titles',
                    icon: 'fas fa-table-list',
                },
                acl: {
                    view                    : 'ACL_00060',
                    detail                  : 'ACL_00061',
                    add                     : 'ACL_00063',
                    edit                    : 'ACL_00065',
                    delete                  : 'ACL_00062',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/modules`,
                    getShow                 : `${codeAPI}/gestao/modules/:id`,
                    getCreate               : `${codeAPI}/gestao/modules`,
                    getUpdate               : `${codeAPI}/gestao/modules/:id`,
                    getDelete               : `${codeAPI}/gestao/modules/:id`,
                },
            },
            users: {
                menu: {
                    route: `${code}.users`,
                    text: 'users.titles',
                    icon: 'fas fa-user',
                },
                acl: {
                    view                    : 'ACL_00008',
                    detail                  : 'ACL_00009',
                    add                     : 'ACL_00012',
                    edit                    : 'ACL_00013',
                    delete                  : 'ACL_00010',
                    state                   : 'ACL_00011',
                    role                    : 'ACL_00450',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/users`,
                    getShow                 : `${codeAPI}/gestao/users/:id`,
                    getCreate               : `${codeAPI}/gestao/users`,
                    getUpdate               : `${codeAPI}/gestao/users/:id`,
                    getDelete               : `${codeAPI}/gestao/users/:id`,
                    getLists                : `${codeAPI}/gestao/users/lists`,
                    getState                : `${codeAPI}/gestao/users/state/:id`,
                },
            },
            roles: {
                menu: {
                    route: `${code}.roles`,
                    text: 'roles.titles',
                    icon: 'fab fa-wpforms',
                },
                acl: {
                    view                    : 'ACL_00014',
                    detail                  : 'ACL_00015',
                    add                     : 'ACL_00017',
                    edit                    : 'ACL_00018',
                    delete                  : 'ACL_00016',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/roles`,
                    getShow                 : `${codeAPI}/gestao/roles/:id`,
                    getCreate               : `${codeAPI}/gestao/roles`,
                    getUpdate               : `${codeAPI}/gestao/roles/:id`,
                    getDelete               : `${codeAPI}/gestao/roles/:id`,
                    getLists                : `${codeAPI}/gestao/roles/lists`,
                },
            },
            notifications: {
                menu: {
                    route: `${code}.notifications`,
                    text: 'notifications.titles',
                    icon: 'fas fa-envelope',
                },
                acl: {
                    view                    : 'ACL_00565',
                    detail                  : 'ACL_00566',
                    add                     : 'ACL_00569',
                    edit                    : 'ACL_00567',
                    delete                  : 'ACL_00568',
                    config                  : 'ACL_00055',
                    configEdit              : 'ACL_00056',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/notifications`,
                    getShow                 : `${codeAPI}/gestao/notifications/:id`,
                    getCreate               : `${codeAPI}/gestao/notifications`,
                    getUpdate               : `${codeAPI}/gestao/notifications/:id`,
                    getDelete               : `${codeAPI}/gestao/notifications/:id`,
                    getTargets              : `${codeAPI}/gestao/notifications/targets`,
                    getLists                : `${codeAPI}/gestao/notifications/lists`,
                    getConfigLists          : `${codeAPI}/gestao/notifications/settings/lists`,
                    getConfig               : `${codeAPI}/gestao/notifications/settings`,
                },
            },
            ogc_remote_services: {
                menu: {
                    route: `${code}.ogc_remote_services`,
                    text: 'ogc_remote_services.titles',
                    icon: 'fas fa-map',
                },
                acl: {
                    view                    : 'ACL_00559',
                    detail                  : 'ACL_00560',
                    add                     : 'ACL_00563',
                    edit                    : 'ACL_00561',
                    delete                  : 'ACL_00562',
                    resources               : 'ACL_00053',
                    harvest                 : 'ACL_00054',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/ogc/remoteservices`,
                    getShow                 : `${codeAPI}/gestao/ogc/remoteservices/:id`,
                    getCreate               : `${codeAPI}/gestao/ogc/remoteservices`,
                    getUpdate               : `${codeAPI}/gestao/ogc/remoteservices/:id`,
                    getDelete               : `${codeAPI}/gestao/ogc/remoteservices/:id`,
                    getLists                : `${codeAPI}/gestao/ogc/remoteservices/lists`,
                    getResources            : `${codeAPI}/gestao/ogc/remoteservices/:id/resources`,
                    getHarvest              : `${codeAPI}/gestao/ogc/remoteservices/:id/harvest`,
                    getReload               : `${codeAPI}/gestao/ogc/remoteservices/:id/reload`,
                },
            },
            database_notifications: {
                menu: {
                    route: `${code}.database_notifications`,
                    text: 'database_notifications.titles',
                    icon: 'fas fa-envelopes-bulk',
                },
                acl: {
                    view                    : 'ACL__00570',
                    detail                  : 'ACL_00571',
                    add                     : false,
                    edit                    : false,
                    delete                  : 'ACL_00572',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/databasenotifications`,
                    getShow                 : `${codeAPI}/gestao/databasenotifications/:id`,
                    getCreate               : `${codeAPI}/gestao/databasenotifications`,
                    getUpdate               : `${codeAPI}/gestao/databasenotifications/:id`,
                    getDelete               : `${codeAPI}/gestao/databasenotifications/:id`,
                    getLists                : `${codeAPI}/gestao/databasenotifications/lists`,
                },
            },
        },
        tools: {

        },
        config: {

        },
    },
};

export default state;